// import { useMakePHPRequest } from '../../../common/useMakePHPRequest';
import { Formik } from 'formik';
import { useMutation } from 'react-query';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { getApiMutation } from '../../../services/rest/getApiMutation';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';
import { ModalWithStyles } from './ModalWithStyles';

export function DeleteConferenceModal({
  setRefetchToggleForBusinessConferences,
  enqueueSnackbarWithStyles,
  userAtom,
  setUserAtom,
  selected,
  handleClose,
  show,
}) {
  // const makeRequest = useMakePHPRequest({
  //   userAtom: userAtom.contents,
  // });
  const mutation = useMutation(getApiMutation(userAtom.contents, setUserAtom));
  return (
    <Formik
      onSubmit={async (values, actions) => {
        if (values.selected.length) {
          for (let i = 0; i < values.selected.length; i++) {
            const data = {
              call: methodNameEnum.DELETE_CONFERENCE,
              apikey: userAtom.contents.apikey,
              businessid: userAtom.contents.businessid,
              conferenceid: values.selected[i].id,
            };
            const response = await mutation.mutateAsync({
              endpoint: endpointEnum.DELETE_CONFERENCE,
              payload: data,
            });
            if (!response?.data?.success) {
              enqueueSnackbarWithStyles({
                message:
                  'Looks like we encountered an error deleting these conference(s)',
                alertProps: { severity: 'warning' },
              });
              break;
            }
            //   const { response } = await makeRequest({
            //     methodName: methodNameEnum.DELETE_CONFERENCE,
            //     payload: {
            //       userid: '',
            // conferenceid: values.selected[i].id,
            //     },
            //   });
            // if (!response.data.meta.success) {
            //   enqueueSnackbarWithStyles({
            //     message:
            //       'Looks like we encountered an error deleting these conference(s)',
            //     alertProps: { severity: 'warning' },
            //   });
            //   break;
            // }
            // }
          }
        }
        handleClose();
        enqueueSnackbarWithStyles({
          message: `Successfully Deleted ${values.selected.length} Conference(s)`,
          alertProps: { severity: 'success' },
        });
        setRefetchToggleForBusinessConferences({});
        actions.resetForm({});
      }}
      enableReinitialize={true}
      initialValues={{
        selected: selected ?? [],
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title="Delete Conference(s)"
              aria-labelledby="example-modal-sizes-title-md"
              show={show}
              onHide={handleClose}
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              deleteDialog={true}
              size="xs"
            >
              <p>
                You are about to delete {formik.values.selected.length} selected
                Conference(s), this procedure is not reversible.
              </p>
              <p>Do you want to proceed?</p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
